module.exports = __webpack_public_path__ + "static/vaping-cover-173329ddc09b27c8fcb4f3c58d18cbc3.png";